export const getActiveStylists = (stylists) => stylists.filter((s) => s.has_column && s.status !== 'deleted' && !s.serves_as_waitlist);
